// extracted by mini-css-extract-plugin
export default {"container":"ProgressPage_container__2+BWY","StatusContainer":"ProgressPage_StatusContainer__zHxz3","image":"ProgressPage_image__HDvQd","scale":"ProgressPage_scale__w7ul1"};